<section
    class="border-[0.7px] border-solid border-[#2a53933b] rounded-[8px] flex items-center shadow-[0px_1px_1px_rgba(6,73,175,0.06)]"
    [ngClass]="isMobile ? 'bg-[#ffffff80] p-[12px_16px]' : 'bg-[#0357ee0d] p-[19px_23px]'">
    <div>
        <img src="assets/images/svgs/moniepoint_logo_icon.svg" alt="">
    </div>
    <div [ngClass]="isMobile ? 'ml-[10px]' : 'ml-[12px]'" >
        <h5 class="font-bold text-[14px] leading-[17px] text-dark-purple" [ngClass]="isMobile ? 'mb-[4px]' : 'mb-[8px]'">
            {{accountName}}
        </h5>
        <p class="font-normal text-[12px] leading-[14px] text-dark-purple mb-[4px]" >
            Acc. No: <span class="font-semibold">{{accountNumber}}</span>
        </p>
        <p class="font-normal text-[12px] leading-[14px] text-dark-purple">
            Balance: <span class="font-semibold">{{ 'moniepoint.currency_symbol'|translate}} {{ balance |majorAmount|currency}}</span>
        </p>
    </div>
</section>